<template>
  <v-card flat>
    <v-alert
      v-if="assetType && assetType.length <= 0"
      outlined
      prominent
      text
      type="error"
      dismissible
    >
      The asset type cannot be empty please check the data and try again.
    </v-alert>
    <template v-else>
      <v-form
        v-model="isValid"
        class="form-asset"
      >
        <slot />
        <v-text-field
          v-model="assetId"
          label="Asset Id"
          :rules="rules.text"
          :counter="MAX_LENGTH"
          hint="Provide a custom asset id"
          required
        />
        <v-text-field
          v-model="assetName"
          label="Asset Name"
          :rules="rules.text"
          :counter="MAX_LENGTH"
          hint="Provide a proper name for this asset"
          required
        />
        <v-textarea
          v-model="details"
          rows="3"
        >
          <template #label>
            <div>
              Description <small>(optional)</small>
            </div>
          </template>
        </v-textarea>
        <v-select
          v-model="currencyType"
          label="Currency"
          :items="currencyTypes"
          item-value="id"
          item-text="label"
          :rules="rules.currencyType"
          required
        />
        <v-text-field
          v-model="assetValue"
          label="Asset Value"
          type="number"
          :rules="rules.number"
          :counter="MAX_LENGTH"
          hint="This is the value that you should add to the asset"
          required
        />
      </v-form>
      <v-card-actions>
        <v-btn
          color="primary"
          text
          large
          @click.stop="onCancelClick"
        >
          Cancel
        </v-btn>
        <v-btn
          large
          color="primary"
          :disabled="!isValid"
          @click.stop="onSubmitData"
        >
          Save
        </v-btn>
      </v-card-actions>
    </template>
  </v-card>
</template>

<script>
import { v4 as uuidv4 } from 'uuid'
import { CURRENCIES_LIST } from '@/dataAccess/currencies'
export default {
  name: 'FormAsset',
  props: {
    assetValues: { type: Object, require, default: null },
    assetType: { type: String, require, default: null }
  },
  data: function () {
    return {
      rules: {
        text: [value => this.rulesAction(value, 'text')],
        number: [value => this.rulesAction(value, 'number')],
        currencyType: [value => this.rulesAction(value, 'currency')]
      },
      uuid: null,
      assetId: null,
      assetName: null,
      assetValue: null,
      details: null,
      currencyType: null,
      currencyTypes: CURRENCIES_LIST,
      isValid: false,
      isReadOnly: false,
      MAX_LENGTH: 40
    }
  },
  beforeMount() {
    this.setLocalValues(this.assetValues)
  },
  methods: {
    onSubmitData() {
      const formData = {
        uuid: this.uuid || uuidv4(),
        assetType: this.assetType,
        assetId: this.assetId,
        assetName: this.assetName,
        assetValue: this.assetValue,
        details: this.details,
        currencyType: this.currencyType
      }

      this.setLocalValues({})
      this.$emit('onSubmitData', formData)
    },
    onCancelClick() {
      this.setLocalValues({})
      this.$emit('onCancelClick', 'assets')
    },
    onRemove() {
      this.setLocalValues({})
      this.$emit('onSubmitData')
    },
    setLocalValues(values) {
      if (values) {
        this.uuid = values.uuid || null
        this.assetId = values.assetId || null
        this.assetName = values.assetName || null
        this.assetValue = values.assetValue || null
        this.details = values.details || null
        this.currencyType = values.currencyType || null
      }
    },
    rulesAction(value, type) {
      if (!value) {
        return 'This field is required.'
      }

      switch (type) {
      case 'text':
        return value.length <= this.MAX_LENGTH || `Max ${this.MAX_LENGTH} characters`
      case 'number':
        return typeof parseInt(value, 10) === 'number' || 'Just numbers are accepted'
      case 'currency':
        const included = this.currencyTypes.some(item => item.id === value)
        return included || 'Select a valid currency property'
      }
    }
  }
}
</script>
